import { useEffect, useRef, useState } from 'react'
import { Controller } from "react-hook-form";
import Select from 'react-select'
// import { errorHandle } from '../../api/api';
import { getAllQueueGroup } from '../../classes/QueueGroup';
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { useToast } from '@chakra-ui/react'

const SelectQueueGroup = ({ control, residenceID, setValue }) => {
    const toast = useToast()
    const [data, setData] = useState([])
    const [options, setOptions] = useState([])

    const loadOption = useRef()
    loadOption.current = () => {
        if (data?.length > 0) {
            const list = data.filter(q => q.residenceID === residenceID)?.map(i => {
                return {
                    label: i.name,
                    value: i.id
                }
            })
            setOptions(list)
            setValue("queue_group", list[0])
        }
    }

    const loadData = useRef()
    loadData.current = async () => {
        await getAllQueueGroup()
            .then(res => {
                if (res) {
                    setData(res)
                }
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(err))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [])

    useEffect(() => {
        loadOption.current()
    }, [data, residenceID])

    return (
        <Controller
            name="queue_group"
            control={control}
            rules={{ required: true }}
            render={({ field }) => <Select
                options={options}
                isLoading={options.length === 0}
                placeholder="เลือก"
                {...field} />}
        />
    )
}

export default SelectQueueGroup